import React from 'react'
import {
  Grid,  Typography } from '@mui/material'
import { map } from '@/utils/lodash'

const LotDetailsForm = ({ lotDetailFields, renderInputFields  }) => (
  <>
    <Grid container style={{ marginTop: 20 }}>
      <Grid size={12}>
        <Typography variant="h6">Lot Details</Typography>
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={1}>
      {map(lotDetailFields, (field) =>
        renderInputFields(false)(field),
      )}
    </Grid>
  </>
)

export default LotDetailsForm
